import { useState, useRef } from "react";
import { countdown } from "../utils";

const useCountDown = (): [
  number,
  {
    start: (seconds: number, key?: string) => void;
    close: () => void;
    restart: (key: string) => void;
  }
] => {
  const [remain, setRemain] = useState(0);
  const closeRef = useRef(() => {});
  const handle = useRef({
    start(seconds: number, key?: string) {
      const endTime = Date.now() + seconds * 1000;
      if (key) {
        try {
          localStorage.setItem(key, String(endTime));
        } catch (e) {
          // ignore
        }
      }
      closeRef.current = countdown(() => {
        const current = Date.now();
        const remain = Math.max(Math.round((endTime - current) / 1000), 0);
        setRemain(remain);
        if (remain <= 0) {
          closeRef.current();
        }
      });
    },
    restart(key: string) {
      let endTime = 0;
      try {
        const valStr = localStorage.getItem(key);
        if (valStr) {
          endTime = Number(valStr);
          if (isNaN(endTime)) {
            endTime = 0;
          }
        }
      } catch (e) {
        // ignore
      }
      const seconds = Math.ceil((endTime - Date.now()) / 1000);
      if (seconds > 0) {
        handle.current.start(seconds);
      } else {
        closeRef.current();
        setRemain(0);
      }
    },
    close() {
      closeRef.current();
      setRemain(0);
    },
  });
  return [remain, handle.current];
};

export default useCountDown;
